import React from 'react';

interface RespectIconProps {
  isMutual: boolean;
  className?: string;
}

/**
 * RespectIcon Component
 * Toont grijs icoon (Respect) of rood icoon (Mutual Respect)
 * Beide SVGs hebben dezelfde viewBox (1280x1024) voor perfecte uitlijning
 */
export const RespectIcon: React.FC<RespectIconProps> = ({ isMutual, className = '' }) => {
  if (isMutual) {
    // Mutual Respect - Rood icoon, wijst naar links
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1280 1024"
        className={className}
        aria-label="Mutual Respect"
      >
        <defs>
          <style>
            {`
              .mutual-cls-1 {
                fill: none;
                stroke: #dc2626;
                stroke-width: 9px;
                stroke-miterlimit: 10;
              }
              .mutual-cls-2 {
                fill: #dc2626;
                stroke: #b3b3b3;
                stroke-width: 3px;
                stroke-miterlimit: 10;
              }
              .mutual-cls-3 {
                font-family: Inter-Bold, Inter, sans-serif;
                font-size: 173.53px;
                font-weight: 700;
                fill: #dc2626;
              }
            `}
          </style>
        </defs>
        <g>
          <path className="mutual-cls-2" d="M1091.58,422.38s-13.42,11.07-89.08,27.05c-62.58,13.22-145.18,25.59-171.87,29.48-5.58.81-8.71,1.25-8.71,1.25"/>
          <path className="mutual-cls-2" d="M1105.7,431.43s-10.15,12.3-73.93,35.75c-52.76,19.39-123.11,39.98-145.85,46.52-4.75,1.37-7.43,2.12-7.43,2.12"/>
          <path className="mutual-cls-1" d="M929.25,432.29c-1.3.3-2.59.46-3.93.5,0,0-93.2,12.18-93.63,12.24l-135.52,8.95c-.79.1-1.6.13-2.4.08l-167.85-10.68c-.37-.02-23.66-.77-24.03-.76-11.86.31-56.71-.96-94.54,3.97-45.49,5.92-70.76,9.21-93.33,25.65-53.52,39-21.27,100.58-73.92,141.62-30.49,23.76-233.04,146.66-228.51,162.09,0,0,330.02-54.41,391.75-54.68,5.16-.21,9.96-2.39,13.11-5.96l65.85-74.59c.36-.41.71-.77,1.12-1.15,6.57-6.12,61.5-53.74,170.53-44.94,56.59,4.57,185.86-21.19,289.29-52.17,86.66-25.96,174.3-90.5,166.73-109-15.56-38.04-162.33-5.4-180.73-1.14Z"/>
        </g>
        <text className="mutual-cls-3" transform="translate(11.52 276.71)">
          <tspan x="0" y="0">mutualrespect</tspan>
        </text>
      </svg>
    );
  }

  // Respect - Grijs icoon, wijst naar rechts
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1280 1024"
      className={className}
      aria-label="Respect"
    >
      <defs>
        <style>
          {`
            .respect-cls-1 {
              fill: none;
              stroke: #6b7280;
              stroke-width: 4px;
              stroke-miterlimit: 10;
            }
            .respect-cls-2 {
              fill: none;
              stroke: #4b5563;
              stroke-width: 2px;
              stroke-miterlimit: 10;
            }
            .respect-cls-3 {
              fill: none;
              stroke: #9ca3af;
              stroke-width: 9px;
              stroke-miterlimit: 10;
            }
            .respect-cls-4 {
              fill: #9ca3af;
              font-family: Inter-Bold, Inter, sans-serif;
              font-size: 176px;
              font-weight: 700;
            }
          `}
        </style>
      </defs>
      <path className="respect-cls-2" d="M130.65,421.84s10.36,12.56,75.51,36.51c53.89,19.81,125.74,40.84,148.98,47.52,4.86,1.4,7.59,2.17,7.59,2.17"/>
      <path className="respect-cls-1" d="M145.08,412.6s13.71,11.31,90.99,27.63c63.92,13.5,148.29,26.14,175.55,30.11,5.7.83,8.9,1.28,8.9,1.28"/>
      <text className="respect-cls-4" transform="translate(242.17 271.43)">
        <tspan x="0" y="0">respect</tspan>
      </text>
      <path className="respect-cls-3" d="M313.54,424.93c1.32.31,2.65.47,4.02.51,0,0,95.2,12.44,95.63,12.5l138.42,9.14c.81.11,1.63.13,2.45.08l171.44-10.91c.37-.02,24.17-.78,24.55-.77,12.11.32,57.93-.98,96.57,4.05,46.46,6.05,72.28,9.41,95.32,26.2,54.67,39.83,21.72,102.74,75.5,144.65,31.14,24.27,238.03,149.8,233.4,165.56,0,0-337.09-55.58-400.14-55.86-5.27-.21-10.17-2.44-13.39-6.09l-67.26-76.19c-.37-.41-.73-.79-1.14-1.17-6.71-6.25-62.81-54.9-174.18-45.9-57.8,4.67-189.84-21.65-295.49-53.29-88.51-26.51-178.03-92.44-170.3-111.34,15.89-38.85,165.81-5.51,184.6-1.17Z"/>
    </svg>
  );
};

export default RespectIcon;
